import React, { useState } from "react";
import { gql, useMutation } from "@apollo/client";

import "./WaitlistForm.css";

const JOIN_WAITLIST = gql`
  mutation JoinWaitlist($email: String!) {
    joinWaitlist(email: $email) {
      success
      message
    }
  }
`;

export default function WaitlistForm({
  placeholder = "Enter your email address...",
  buttonText = "Join the Waitlist",
  loadingText = "Joining...",
  successText = "You're on the waitlist!",
  inputClassName = "zenit-card-input",
  buttonClassName = "zenit-card-btn waitlist",
  formClassName = "",
  layout = "default",
}) {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [joinWaitlist, { data, loading, error }] = useMutation(JOIN_WAITLIST);

  const isSuccess = Boolean(data?.joinWaitlist?.success);
  const formClasses = [
    "waitlist-form",
    layout === "stacked" ? "waitlist-form--stacked" : "",
    formClassName,
  ]
    .filter(Boolean)
    .join(" ");

  const handleSubmit = async (event) => {
    event.preventDefault();
    await joinWaitlist({ variables: { email } });
    setSubmitted(true);
  };

  return (
    <form className={formClasses} onSubmit={handleSubmit}>
      <div className="waitlist-form__field">
        <input
          type="email"
          className={inputClassName}
          placeholder={placeholder}
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          disabled={loading || submitted || isSuccess}
          required
        />
      </div>

      <div className="waitlist-form__actions">
        <button
          className={buttonClassName}
          type="submit"
          disabled={loading || !email || submitted || isSuccess}
        >
          {isSuccess ? successText : loading ? loadingText : buttonText}
        </button>
      </div>

      {error && (
        <div className="waitlist-form__feedback waitlist-form__feedback--error">
          {error.message}
        </div>
      )}

      {data?.joinWaitlist?.message && (
        <div className="waitlist-form__feedback waitlist-form__feedback--success">
          {data.joinWaitlist.message}
        </div>
      )}
    </form>
  );
}
